import React, { useContext, useEffect, useState } from 'react';
import Modal from '../Modal/Modal';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { CancelButton, ConfirmationButton } from '../Button';
import { Flex } from '@chakra-ui/react';
import { HandTitle, ReloadableHuella } from './Misc';
import { ArrowLeft, ArrowRight } from 'react-feather';
import { BiometricContext } from '../../utility/context/Biometric';
import LoadingModal from '../../views/FichasActivas/NuevaFicha/Modals/LoadingModal';
import { PoppinsSemiBold } from '../Fonts';
import { ReactComponent as IconAceptar } from '../../assets/images/icons/ico_aceptar_green.svg';
import { useCaptureBiometrics } from './hooks';

NiceModal.register('modal-loading', LoadingModal);

const mano_kojak_handler = {
	izquierda: 'L',
	derecha: 'R'
};

const dedo_kojak_handler = {
	pulgar: 'T',
	indice: 'I',
	medio: 'M',
	anular: 'R',
	menique: 'L'
};
const ModalHuellas = ({ biometric_id, initialCaptured }) => {
	const modal = useModal();
	const [dedos, setDedos] = useState(initialCaptured || []);
	const [isLoading, setIsLoading] = useState(false);

	const { queue, iniciarQueueCaptura, captured } = useCaptureBiometrics();
	const { biometricos, newMessage } = useContext(BiometricContext);
	const handleSubmit = () => {
		modal.resolve([...dedos]);
		modal.remove();
	};

	const handleCancel = () => {
		modal.reject(null);
		modal.remove();
	};

	useEffect(() => {
		if (!queue?.length) {
			setIsLoading(false);
		} else {
			setIsLoading(true);
		}
	}, [queue]);

	useEffect(() => {
		if (captured?.length) {
			const lastCaptured = captured[0];
			const newDedos = dedos.map((dedo) =>
				dedo.id === lastCaptured.id ? lastCaptured : dedo
			);
			setDedos(newDedos);
		}
	}, [captured]);

	return (
		<Modal title="Resultados de escaneo" size="lg" autoFocus={false}>
			<ModalBody>
				<Flex direction="column" minHeight="420px">
					{biometricos.length &&
					newMessage?.type !== 'biometrico_desconectado' ? (
						<PoppinsSemiBold
							as="span"
							color="#2E353A"
							sx="16px"
							textAlign="center"
							height="32px"
						>
							Biométrico conectado <IconAceptar />
						</PoppinsSemiBold>
					) : (
						<PoppinsSemiBold
							as="span"
							color="#2E353A"
							sx="16px"
							textAlign="center"
							height="32px"
						>
							Biométrico desconectado
						</PoppinsSemiBold>
					)}
					<Flex
						position="relative"
						marginTop="1.5rem"
						marginBottom="1rem"
						alignItems="center"
						justifyContent="space-around"
					>
						<HandTitle>
							<ArrowLeft color="green" /> Mano Izquierda
						</HandTitle>
						<HandTitle>
							Mano Derecha <ArrowRight color="green" />
						</HandTitle>
					</Flex>
					<Flex
						direction="row"
						alignItems="center"
						justifyContent="space-around"
					>
						<Flex
							gap={20}
							wrap="wrap"
							justifyContent="space-evenly"
							width="50%"
							maxWidth="330px"
						>
							{dedos
								?.filter((dedo) => dedo.mano_id === 'izquierda')
								.map((dedo) => {
									return (
										<ReloadableHuella
											caption={`${dedo.dedo_id}`}
											onClick={() => {
												let request_type = '1';
												if (dedo.biometric_type === 2) {
													request_type =
														request_type +
														mano_kojak_handler[dedo.mano_id] +
														dedo_kojak_handler[dedo.dedo_id];
												}
												iniciarQueueCaptura(
													[dedo],
													dedo.biometric_type === 1 ? 1 : null,
													biometric_id,
													dedo.biometric_type !== 1 ? request_type : '1'
												);
											}}
											src={dedo?.png}
											reloading={isLoading}
										/>
									);
								})}
						</Flex>
						<div
							style={{
								width: '2px',
								backgroundColor: '#CACACA',
								height: '70%',
								position: 'absolute',
								opacity: '50%',
								top: '20%'
							}}
						/>
						<Flex
							gap={20}
							wrap="wrap"
							justifyContent="space-evenly"
							width="50%"
							maxWidth="330px"
						>
							{dedos
								.filter((dedo) => dedo.mano_id === 'derecha')
								.map((dedo) => {
									return (
										<ReloadableHuella
											caption={`${dedo.dedo_id}`}
											onClick={() => {
												let request_type = '1';
												if (dedo.biometric_type === 2) {
													request_type =
														request_type +
														mano_kojak_handler[dedo.mano_id] +
														dedo_kojak_handler[dedo.dedo_id];
												}
												iniciarQueueCaptura(
													[dedo],
													dedo.biometric_type === 1 ? 1 : null,
													biometric_id,
													dedo.biometric_type !== 1 ? request_type : '1'
												);
											}}
											src={dedo?.png}
											reloading={isLoading}
										/>
									);
								})}
						</Flex>
					</Flex>
				</Flex>
			</ModalBody>
			<ModalFooter className="modal-footer-buttons">
				<CancelButton
					onClick={handleCancel}
					label="Cancelar"
					disabled={isLoading}
				/>
				<ConfirmationButton
					autoFocus
					onClick={handleSubmit}
					label="Aceptar resultados"
					disabled={isLoading}
				/>
			</ModalFooter>
		</Modal>
	);
};

export default NiceModal.create(ModalHuellas);
